const getImageStyles = aspectRatio => ({
  height: 'var(--size-image-height)',
  width: `calc(var(--size-image-height) * ${aspectRatio})`,
  pointerEvents: 'none',
});

const horizontalDragScroll = (scrollEl, activatorEl = scrollEl) => {
  let isClicked = false;
  let isInertiaScrolling = false;
  let speedX = 0;
  let prevScrollLeft;

  function inertiaScroll() {
    speedX -= speedX * 0.03;
    scrollEl.scrollLeft -= speedX;

    if (isClicked || prevScrollLeft === scrollEl.scrollLeft) {
      isInertiaScrolling = false;
      speedX = 0;
      return;
    }

    prevScrollLeft = scrollEl.scrollLeft;

    if (Math.abs(speedX) >= 1) requestAnimationFrame(inertiaScroll);
    else isInertiaScrolling = false;
  }

  function mouseUpLeaveHandler() {
    isClicked = false;

    if (speedX && !isInertiaScrolling) {
      isInertiaScrolling = true;
      requestAnimationFrame(inertiaScroll);
    }
  }

  function mouseMoveHandler(e) {
    if (!isClicked) return;

    e.preventDefault();
    speedX = e.movementX;
    scrollEl.scrollLeft -= speedX;
  }

  function mouseDownHandler(e) {
    e.preventDefault();
    isClicked = true;
  }

  function init() {
    activatorEl.style.cursor = 'ew-resize';
    activatorEl.addEventListener('mousedown', mouseDownHandler);
    activatorEl.addEventListener('mousemove', mouseMoveHandler);
    activatorEl.addEventListener('mouseup', mouseUpLeaveHandler);
    activatorEl.addEventListener('mouseleave', mouseUpLeaveHandler);
  }

  function destroy() {
    activatorEl.style.cursor = '';
    activatorEl.removeEventListener('mousedown', mouseDownHandler);
    activatorEl.removeEventListener('mousemove', mouseMoveHandler);
    activatorEl.removeEventListener('mouseup', mouseUpLeaveHandler);
    activatorEl.removeEventListener('mouseleave', mouseUpLeaveHandler);
  }

  init();

  return destroy;
};

export { getImageStyles, horizontalDragScroll };
